import React, { useState, useEffect } from 'react';
import styled, { withTheme } from 'styled-components'
import Chart from 'react-apexcharts';

import { Box } from 'vqp-common'
import { CardTitle } from './'

const ptBr = require('apexcharts/dist/locales/pt-br.json')

const getDefaultChartOptions = () => ({
    chart: {
        id: "basic-bar",
        toolbar: {
            show: false
        }
    },
    stroke: {
        width: [2, 4]
    },
    legend: {
        position: 'top',
        horizontalAlign: 'left',
        width: 200,
    },
    dataLabels: {
        offsetY: -25,
        style: {
            colors: ['#000000']
        }
    },
    plotOptions: {
        bar: {
            dataLabels: {
                position: 'top', // top, center, bottom,
            },
        },
    },
})

const getDefaultColors = (theme) => (
    [
        theme.colors.primary,
        theme.colors.secondary
    ]
)

const Wrapper = styled.div``

export const BarChart = withTheme (({title, labels, datasets, type, theme, xaxis, yFormatters, labelFormatter}) => {
    const defaultColors = getDefaultColors(theme)
    const chartOptions = getDefaultChartOptions();

    const [chartSeries, setChartSeries] = useState([])

    const safeLabels = Array.isArray(labels) ? labels : [];
    const safeDatasets = (Array.isArray(datasets) ? datasets : []).filter(Boolean);

    chartOptions.labels = safeLabels;
    chartOptions.yaxis = safeDatasets.map( (dataset, i) => ({
        opposite: i % 2 !== 0,
        axisTicks: {
            show: true
        },
        title: {
            text: dataset?.name ?? dataset?.label ?? ''
        },
        forceNiceScale: true,
        decimalsInFloat: 1
    }))
    if (yFormatters) {
        chartOptions.yaxis.forEach( (axis, i) => {
            if (yFormatters[i]) {
                axis.labels = {
                    formatter: yFormatters[i]
                }
            }
        })
    }
    if (labelFormatter) {
        chartOptions.dataLabels.formatter = labelFormatter
    }
    chartOptions.chart.locales = [ptBr]
    chartOptions.chart.defaultLocale = 'pt-br'

    if (xaxis) {
        chartOptions.xaxis = { ...xaxis };
        if (xaxis.type === 'datetime') {
            chartOptions.xaxis.labels = { ...(chartOptions.xaxis.labels || {}), datetimeFormatter: { year: 'yyyy', month: "MMM 'yy", day: 'dd MMM', hour: 'HH:mm' } };
        }
    }
    // Preenchimento sob a linha para ficar visível
    chartOptions.fill = { type: 'solid', opacity: [0.25, 0.1] };
    chartOptions.stroke = { width: [3, 2], curve: 'smooth' };

    // Formato dos dados: com xaxis datetime, ApexCharts espera [ [x, y], ... ]
    const isDatetime = xaxis && xaxis.type === 'datetime';
    const buildSeriesData = (dataset) => {
        const rawData = Array.isArray(dataset?.data) ? dataset.data : [];
        if (isDatetime && safeLabels.length > 0) {
            return safeLabels.map((x, i) => [Number(x), Number(rawData[i] ?? 0)]);
        }
        return rawData.map((v) => Number(v));
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setChartSeries(
                safeDatasets.map((dataset) => ({
                    name: dataset?.label ?? dataset?.name ?? '',
                    data: buildSeriesData(dataset),
                    type: dataset?.type || 'column'
                }))
            );
        }, 100);
        return () => clearTimeout(timeoutId);
    }, [datasets, labels, xaxis]);

    chartOptions.colors = safeDatasets.map((dataset, i) => dataset?.color || defaultColors[i]);

    const hasValidSeries = chartSeries.length > 0 && chartSeries.every((s) => Array.isArray(s?.data));

    return (
        <Wrapper>
            <CardTitle>{title}</CardTitle>
            <Box padding={"20px"}>
                {hasValidSeries ? (
                    <Chart
                        options={chartOptions}
                        series={chartSeries}
                        type={type}
                        height={290}
                    />
                ) : null}
            </Box>
        </Wrapper>
    )
})